// @flow

import {
  CREATE_RECORD_SUCCESS,
  CREATE_RECORD_ERROR,
  RECORD_FORM_ON_CHANGE,
  UPLOAD_IMAGE_SUCCESS,
  DELETE_UPLOAD_IMAGE,
  RESET_RECORD_FORM,
  RESET_UPLOAD_IMAGE,
} from '../constants'

type State = {
  isRecordCreated: boolean,
  error: string,
  newRecord: {
    taobaoOrderId: string,
    deliveryTrackingNumber: string,
    notes: string,
    isDamaged: boolean,
    images: Array<string>,
  },
}

const initialState = {
  isRecordCreated: false,
  error: '',
  newRecord: {
    taobaoOrderId: '',
    deliveryTrackingNumber: '',
    notes: '',
    isDamaged: false,
    images: [],
  },
}

function warehouse(state: State = initialState, action: { type: string, payload: any }) {
  switch (action.type) {
    case CREATE_RECORD_SUCCESS:
      return {
        ...state,
        isRecordCreated: action.payload,
        newRecord: {
          orderId: '',
          tractkingNumber: '',
          notes: '',
          isDamaged: false,
          images: [],
        },
      }
    case CREATE_RECORD_ERROR:
      return {
        ...state,
        error: action.payload
      }
    case RESET_RECORD_FORM:
      return {
        ...state,
        isRecordCreated: action.payload,
        newRecord: {
          taobaoOrderId: '',
          deliveryTrackingNumber: '',
          notes: '',
          isDamaged: false,
          images: [],
        }
      }
    case RECORD_FORM_ON_CHANGE:
      action.payload.isDamaged = action.payload.isDamaged + '' === 'true'
      return {
        ...state,
        newRecord: action.payload
      }
    case UPLOAD_IMAGE_SUCCESS:
      return {
        ...state,
        newRecord: {
          ...state.newRecord,
          images: state.newRecord.images.concat(action.payload)
        }
      }
    case RESET_UPLOAD_IMAGE:
      return {
        ...state,
        newRecord: {
          ...state.newRecord,
          images: action.payload
        }
      }
    case DELETE_UPLOAD_IMAGE:
      return {
        ...state,
        newRecord: {
          ...state.newRecord,
          images: state.newRecord.images.filter(url => url !== action.payload)
        }
      }
    default:
      return state
  }
}

export default warehouse



// WEBPACK FOOTER //
// ./src/modules/warehouse.js